import DirectApi from '../../../../directApi';
import {SearchQueryResult} from './types/SearchResult';
import {SearchSuggestion} from './types/SearchSuggestion';

export const searchSuggestionQuery = (recentTaskId: string | null): Promise<SearchSuggestion[]> => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	return DirectApi.Fetch_Raw_With_Init('globalsearch/suggestions', {
		method: 'POST',
		credentials: 'include',
		headers,
		body: JSON.stringify({recentTaskId}),
	})
		.then(response => response.json())
		.then(data => data);
};

type AccessibleProjects = {
	projectIds: number[];
	projectGroupIds: number[];
};

export type SearchQueryResponse = {
	searchResults: SearchQueryResult[];
	accessibleProjectIds: AccessibleProjects;
};

export const searchQuery = (
	queryString: string,
	projectId: number | null | undefined,
	endpoint: string,
	abortSignal: AbortSignal,
	personId: number | null
): Promise<SearchQueryResponse> => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	return DirectApi.Fetch_Raw_With_Init('globalsearch', {
		method: 'POST',
		credentials: 'include',
		headers,
		body: JSON.stringify({queryString, projectId, endpoint, registeringOnUserId: personId}),
		signal: abortSignal,
	})
		.then(response => response.json())
		.then(data => data)
		.catch(() => {
			console.log('Search query aborted');
		});
};
